// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1xZWC","overflowing":"ReadFullNote_overflowing__1MUYb"};